import React from 'react';
import { motion } from 'framer-motion';
import styles from './Badge.module.css';

type BadgeVariant = 'green' | 'red' | 'yellow' | 'blue' | 'purple';

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
}

// Only green gets a live pulsing dot
const liveDotVariants: Partial<Record<BadgeVariant, boolean>> = {
  green: true,
};

export function Badge({ variant = 'blue', children }: BadgeProps) {
  const showDot = liveDotVariants[variant] ?? false;

  return (
    <motion.span
      className={[styles.badge, styles[variant]].join(' ')}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ type: 'spring', stiffness: 500, damping: 24 }}
    >
      {showDot && (
        <span className={[styles.dot, styles['dot-green'], styles.animated].join(' ')} />
      )}
      {children}
    </motion.span>
  );
}
